import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit"
import toast from "react-hot-toast"
import { api } from "../../api"
import ToastAction from "../../components/ToastAction"

export const fetchUsers = createAsyncThunk('users/fetchUsers', async ({ company_id }) => {
  const users = await api.user().getUsersByCompany(company_id)
  return users
})

export const updateUser = createAsyncThunk('users/updateUser', async ({ company_id, requested_user_id, admin_user, allowance_websites }) => {
  await api.user().updateUserCompany({ company_id, requested_user_id, admin_user, allowance_websites })
  return { company_id, id: requested_user_id, admin: admin_user, allowance_websites }
})

export const deleteUser = createAsyncThunk('users/deleteUser', async ({ company_id, requested_user_id }) => {
  await api.user().deleteUser(company_id, requested_user_id)
  return requested_user_id
})



const userAdapter = createEntityAdapter({
  selectId: (user) => user.id,
})

const usersSlice = createSlice({
  name: 'manageUsers',
  initialState: userAdapter.getInitialState({ loading: false, error: { status: false, message: '' }, showMessage: false, idLoading: null }),
  reducers: {
    closeMessageUser: (state, _action) => {
      state.showMessage = false
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchUsers.pending, (state, _action) => {
      state.loading = true;
    })
      .addCase(fetchUsers.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.error = { status: false, message: null }
        userAdapter.setAll(state, payload);
      })
      .addCase(fetchUsers.rejected, (state, { error }) => {
        state.loading = false
        state.error = { status: true, message: error.message }
      })
      .addCase(updateUser.pending, (state, _action) => {
        state.loading = true;
        state.idLoading = toast.loading('Enregistrement en cours...');
      })
      .addCase(updateUser.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.showMessage = true
        state.error = { status: false, message: '' };
        userAdapter.updateOne(state, payload);
        toast.dismiss(state.idLoading)
      })
      .addCase(updateUser.rejected, (state, { error }) => {
        state.loading = false;
        state.error = { status: true, message: error.message }
        toast.custom(t =>
          <ToastAction
            toastRef={t}
            label='Oups !!'
            description="Nous avons rencontré un problème lors de l'enregistrement de votre utilisateur. Veuillez réessayer SVP !"
            saraExpression="sorry"
          />
        )
        toast.dismiss(state.idLoading)
      })
      .addCase(deleteUser.pending, (state, _action) => {
        state.loading = true;
        state.idLoading = toast.loading('Suppression en cours...')
      })
      .addCase(deleteUser.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.error = { status: false, message: '' };
        userAdapter.removeOne(state, payload);
        toast.custom(t =>
          <ToastAction
            toastRef={t}
            label='Yeah !!'
            description="Votre utilisateur a bien été supprimé."
            saraExpression="wink"
          />
        )
        toast.dismiss(state.idLoading)
      })
      .addCase(deleteUser.rejected, (state, { error }) => {
        state.loading = false;
        state.error = { status: true, message: error.message }
        toast.custom(t =>
          <ToastAction
            toastRef={t}
            label='Oups !!'
            description="Nous avons rencontré un problème lors de la suppression de ce compte. Veuillez réessayer SVP !"
            saraExpression="sorry"
          />
        )
        toast.dismiss(state.idLoading)
      })
  }
})

const usersSelector = userAdapter.getSelectors(state => state.users);

export const { closeMessageUser } = usersSlice.actions

export const {
  selectAll: getUsers,
  selectTotal: getTotalUsers
} = usersSelector;

export default usersSlice.reducer;